import {

  CORE_LOAD_TERM_REQUEST,
  CORE_LOAD_TERM_SUCCESS,

  CORE_UPDATE_TERM_REQUEST,
  CORE_UPDATE_TERM_SUCCESS,
} from '../../../types'

const initialState = {}
export default {
  term: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_TERM_REQUEST:
      case CORE_UPDATE_TERM_REQUEST:
        return initialState

      case  CORE_LOAD_TERM_SUCCESS:
      case CORE_UPDATE_TERM_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/settings/term/reducer.js